module.exports = __webpack_public_path__ + "img/handwriting@1x.39e318ae.png";